<template>
  <div
    class="flex overflow-hidden rounded-xl border border-gray-200 bg-white shadow-sm"
  >
    <!-- Thumbnail -->
    <div class="relative h-[120px] w-[120px] flex-shrink-0 bg-gray-100">
      <img
        :src="currentImageUrl"
        :alt="title"
        class="h-full w-full object-cover"
        loading="lazy"
        @error="onImageError"
      />
    </div>
    <!-- Content -->
    <div class="flex min-w-0 flex-1 flex-col justify-center gap-1 px-4 py-3">
      <span
        class="text-[10px] font-medium uppercase tracking-wider text-gray-400"
        >{{ siteHost }}</span
      >
      <h3 class="truncate text-sm font-bold text-[#2e234b]">{{ title }}</h3>
      <p class="line-clamp-2 text-xs text-gray-500">{{ description }}</p>
      <div class="mt-1 flex items-center gap-3 text-[11px] text-gray-400">
        <span v-if="date">{{ date }}</span>
        <span v-if="date && location" class="text-gray-300">·</span>
        <span v-if="location">{{ location }}</span>
        <span v-if="(date || location) && price" class="text-gray-300">·</span>
        <span v-if="price" class="font-semibold text-pink-500">{{
          price
        }}</span>
      </div>
    </div>
  </div>
</template>

<script setup lang="ts">
import { computed, ref, watch } from "vue";

const { SITE_URL } = usePublicUrls();

const siteHost = computed(() => {
  try {
    return new URL(SITE_URL).host;
  } catch {
    return SITE_URL;
  }
});

const props = defineProps<{
  title: string;
  description: string;
  imageUrl: string;
  url: string;
  type: "event" | "establishment";
  date?: string;
  location?: string;
  price?: string;
}>();

const fallbackImageUrl = computed(() =>
  props.type === "event"
    ? "/images/placeholder-soft-neutral-event.svg"
    : "/images/placeholder-soft-neutral-venue.svg",
);
const currentImageUrl = ref(fallbackImageUrl.value);

watch(
  () => [props.imageUrl, fallbackImageUrl.value] as const,
  ([imageUrl, fallback]) => {
    currentImageUrl.value = imageUrl?.trim() || fallback;
  },
  { immediate: true },
);

function onImageError() {
  currentImageUrl.value = fallbackImageUrl.value;
}
</script>
